import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { clamp } from '../../util/functions';
import { formatTime, parseTime } from '../../util/time';

export interface TimeInputProps {
  valueMs: number;
  minMs: number;
  maxMs: number;
  onChange: (ms: number) => void;
  ariaLabel: string;
}

export const TimeInput: React.FC<TimeInputProps> = ({
  valueMs,
  minMs,
  maxMs,
  onChange,
  ariaLabel,
}) => {
  const [text, setText] = useState(formatTime(valueMs));

  useEffect(() => {
    setText(formatTime(valueMs));
  }, [valueMs]);

  const commit = (raw: string) => {
    const parsed = parseTime(raw);
    if (parsed == null) {
      setText(formatTime(valueMs));
      return;
    }
    onChange(clamp(parsed, minMs, maxMs));
  };

  const adjust = (deltaMs: number) => {
    onChange(clamp(valueMs + deltaMs, minMs, maxMs));
  };

  return (
    <TextField
      value={text}
      onChange={(e) => setText(e.target.value)}
      onBlur={(e) => commit(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') (e.target as HTMLInputElement).blur();
        if (e.key === 'ArrowUp') {
          e.preventDefault();
          adjust(1000);
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          adjust(-1000);
        }
      }}
      size="small"
      inputProps={{
        'aria-label': ariaLabel,
        style: { fontVariantNumeric: 'tabular-nums', width: 40 },
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end" sx={{ ml: 0 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <IconButton
                size="small"
                aria-label={`${ariaLabel} up`}
                onClick={() => adjust(1000)}
                sx={{ p: 0, height: 14, width: 18 }}
              >
                <KeyboardArrowUp sx={{ fontSize: 14 }} />
              </IconButton>
              <IconButton
                size="small"
                aria-label={`${ariaLabel} down`}
                onClick={() => adjust(-1000)}
                sx={{ p: 0, height: 14, width: 18 }}
              >
                <KeyboardArrowDown sx={{ fontSize: 14 }} />
              </IconButton>
            </Box>
          </InputAdornment>
        ),
      }}
      sx={{ width: 96 }}
    />
  );
};
